/// <reference path='../_all.ts' />

module part {
  'use strict';


  export class DocumentCategory {
    constructor(
      public DocumentCategoryID : number,
      public DocumentCategoryName : string,
      public Types : DocumentType[]
      ) { }
  }

  export class DocumentType {
    constructor(
      public DocumentTypeID : number,
      public DocumentTypeName : string,
      public Documents : Document[]
      ) { }
  }

  export class Document {
    constructor(
      public DocumentID : number,
      public DocumentTitle : string,
      public Revisions : DocumentRev[]
      ) { }
  }

  export class DocumentRev {
    constructor(
      public DocumentFileSrcRevID : number,
      public DocumentRevDestID : number,
      public DocumentRevDestSize : number,
      public FileTypeExt : string,
      public FileTypeName : string,
      public LanguageCode : string,
      public DocumentFileSrcName : string,
      public DocumentFileSrcRevName : string
      ) { }
  }

  export class TErsatzteillisteDocDataTable {
    constructor(
      public DocumentFileSrcRevName : number,
      public DocumentRevDestID : number,
      public FileDocuName : number,
      public FileName : number,
      public NavProduktNummer
      ) { }
  }


  export class DocumentImage {
    constructor(
      public Height : number,
      public Width : number,
      public OriginalHeight : number,
      public OriginalWidth : number,
      public RevDestId : number,
      public RevDestName : string,
      public TitleD : string,
      public TitleE : string,
      public MaxSideLength : number,
      public Url : string,
      public ImageUrl : string,
      public ImageUrlRetina : string
    ) { }
  }

}








